module.exports = __webpack_public_path__ + "img/mobilehardware1.aa369e60.png";